export default "__VITE_ASSET__DGI_1VnY__"